module.exports = __webpack_public_path__ + "img/goggles2_TH.e14b7737.png";